import { useAuthContext } from 'contexts/AuthContext';
import { useCallback, useEffect, useMemo, useState } from 'react';

/**
 * Hook pour gérer l'affichage du logo du Account de l'utilisateur.
 * @returns { show: boolean, logoUrl: string | null, handleError: () => void }
 * - show: indique si le logo doit être affiché
 * - logoUrl: l'URL du logo à afficher
 * - handleError: fonction à appeler en cas d'erreur de chargement de l'image
 */
export const useAccountLogo = () => {
  const { auth } = useAuthContext();
  const [show, setShow] = useState(false);

  const logoUrl = useMemo(() => {
    const url = auth?.user?.logoUrl;
    return typeof url === 'string' ? url : null;
  }, [auth]);

  const isValidLogoUrl = useCallback((url?: string | null) => {
    return !(!url || typeof url !== 'string');
  }, []);

  useEffect(() => {
    setShow(isValidLogoUrl(logoUrl));
  }, [logoUrl, isValidLogoUrl]);

  const handleError = useCallback(() => setShow(false), []);

  return { show, logoUrl, handleError } as const;
};
